import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "./layout/Auth";
import Main from "./layout/Main";
import routes from "./routes";
import { getTableData } from "./store/actions/cartAction";

function App() {
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.authUser);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);

  useEffect(() => {
    if (restaurantsDetail?.restaurantID) {
      dispatch(getTableData(restaurantsDetail.restaurantID));
    }
  }, [restaurantsDetail, dispatch]);

  return (
    <>
      <BrowserRouter>
        <Switch>
          {routes.map((route, index) =>
            uid && route.layout === "auth" ? (
              <Redirect key={index} exact from={route.path} to="/restaurants" />
            ) : (
              <Route key={index} exact path={route.path}>
                {route.layout === "main" ? (
                  <Main>
                    <route.component />
                  </Main>
                ) : (
                  <Auth>
                    <route.component />
                  </Auth>
                )}
              </Route>
            )
          )}
          <Redirect to="/main" />
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
